<template>
  <vx-card>
    <div v-if="hasAdminPermission" class="w-full mb-20">
      <vs-button color="secondary" @click="onClickSave" class="float-right">{{ $t('저장') }}</vs-button>
    </div>

    <div>
      <!-- 이미지 업로드 -->
      <photo-upload-grid-module v-if="hasAdminPermission" :row-count="1" :grid-count="1" :showFooterInput="false" v-model="form.images" :is-print="isPrint" class="mt-28px" />
      <div v-else>
        <div v-for="(img, img_i) in form.images" :key="`img_${img_i}`">
          <img v-if="img.path" :src="img.path" class="w-full mx-auto mb-4" />
        </div>
      </div>

      <!-- 파일첨부 -->
      <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="!hasAdminPermission"></file-upload-module>
    </div>
  </vx-card>
</template>

<script>
import FileDownload from "@/components/FileDownload.vue";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";

export default {
  components: {
    FileDownload,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    docProjectId: String | Number,
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
    hasAdminPermission() {
      return parseInt(this.$store.state.auth.userInfo.is_superuser) === 1;
    },
  },
  created() {
    this.init();
  },
  data() {
    return {
      form: {
        images: [],
        fileList: [],
      },
    };
  },
  methods: {
    async init() {
      const projectId = this.projectId;
      const boardId = this.boardId;
      const page = 1;
      const perPage = 1;
      const orderTarget = "created_at";
      const orderDirection = "desc";

      const response = await this.$store.dispatch("board/LOAD_POST_LIST", { projectId, boardId, page, perPage, orderTarget, orderDirection });
      const data = JSON.parse(response.data[0].post_content).body;
      this.form = data;
      if (0 < response.data.length) {
        const data = JSON.parse(response.data[0].post_content).body;
        this.form = data;
      }
    },
    onClickSave() {
      this.saveBoardPost("create");
    },

    async saveBoardPost(type) {
      const form = {
        header: {
          full: new Date().format("yyyy-MM-dd"),
          month: new Date().getMonth() + 1,
          year: new Date().getFullYear(),
        },
        body: this.form,
        summary: {},
      };

      const projectId = this.projectId;
      const boardId = this.boardId;
      const title = "경영방침";
      const content = JSON.stringify(form);

      await this.$store.dispatch("board/CREATE_POST", {
        projectId,
        boardId,
        title,
        content,
      });
      this.oldForm = JSON.parse(JSON.stringify(this.form));
    },
  },
};
</script>

<style scoped lang="scss"></style>
